import { CustomEvent } from '../../../../../Foundation/Shared/platform/app';
import { getCartElement } from './utilities';

window.addEventListener(CustomEvent.ShellModuleRendered, () => {
  'use strict';

  const cartElement: HTMLElement = getCartElement();
  if (!cartElement) {
    document.documentElement.classList.add('ecom-disabled');
  }
});
